import {createContext, useState} from "react";
import {
    getCurrentBusDateOrCurrentDate,
    getCurrentDateToDatePickerFormat,
    getPreviousDateToDatePickerFormat
} from "utils/FormatUtils";

export const SWIFT_TRANSACTION_PANEL_HOME_PAGE = "admin/swift-transactions";

export const Context = createContext({});
const startEndDate = getCurrentBusDateOrCurrentDate();

const initSwiftTransactionFilterState = {
    status: 'ALL',
    transId: '',
    msgType: 'ALL',
    effective: startEndDate
}

const initSwiftTransactionResultsDisplay = {
    wireSearch:{},
    resData:[]
}

const initSwiftTranPanelPageState = {
    currentPage : SWIFT_TRANSACTION_PANEL_HOME_PAGE,
}

export const Provider = props => {

    const {children} = props;
    const [swiftTransactionPanelFilterState, setSwiftTransactionPanelFilterState] = useState(JSON.parse(JSON.stringify(initSwiftTransactionFilterState)));
    const [swiftTransactionResultsDisplayState, setSwiftTransactionResultsDisplayState] = useState(JSON.parse(JSON.stringify(initSwiftTransactionResultsDisplay)));
    const [SwiftTransactionPanelPageState, setSwiftTransactionPanelPageState] = useState(JSON.parse(JSON.stringify(initSwiftTranPanelPageState)));
    const [handleApproveFunction, setHandleApproveFunction] = useState(null);
    const [handleRejectFunction, setHandleRejectFunction] = useState(null);
    const [showGridToolbar, setShowGridToolbar] = useState(true);
    const [selectedAnyCheckbox, setSelectedAnyCheckbox] = useState(false);
    const [selectedRows, setSelectedRows] = useState([])

    const handleApprove = (onSuccess, onError) => {
        handleApproveFunction.handleApprove(
            handleApproveFunction.gridApi, onSuccess, onError);
    }

    const handleReject = (onSuccess, onError) => {
        handleRejectFunction.handleReject(
            handleRejectFunction.gridApi, onSuccess, onError);
    }

    const clearSwiftTransactionPanelDisplayState = () => {
        const clearSwiftTransactionPanelFilterState = JSON.parse(JSON.stringify(initSwiftTransactionFilterState));
        setSwiftTransactionPanelFilterState(clearSwiftTransactionPanelFilterState);

        const clearSwiftTransactionResultsDisplayState = JSON.parse(JSON.stringify(initSwiftTransactionResultsDisplay));
        setSwiftTransactionResultsDisplayState(clearSwiftTransactionResultsDisplayState);

        const clearSwiftTransactionPanelPageState = JSON.parse(JSON.stringify(initSwiftTranPanelPageState));
        setSwiftTransactionPanelPageState(clearSwiftTransactionPanelPageState);

    }
    const displayStatusMapping = {
        "Pend":  "Pend",
        "Appr": "Approved",
        "Cmplt": "Completed",
        "Reject": "Reject",
        "ALL": "ALL"
    }

    const getDisplayStatusFromValue = (value) => {
        if (value){
            return displayStatusMapping[value];
        } else {
            return "";
        }
    }

    const displaySwiftTransactionPanelPage = (SwiftTransactionPanelPage) => {
        let SwiftTransactionPanelPageStateToShow =JSON.parse(JSON.stringify(SwiftTransactionPanelPageState));
        SwiftTransactionPanelPageStateToShow.currentPage = SwiftTransactionPanelPage;
        setSwiftTransactionPanelPageState(SwiftTransactionPanelPageStateToShow);
    }

    const swiftTransactionPanelContext = {
        swiftTransactionPanelFilterState,
        setSwiftTransactionPanelFilterState,
        swiftTransactionResultsDisplayState,
        setSwiftTransactionResultsDisplayState,
        SwiftTransactionPanelPageState,
        setSwiftTransactionPanelPageState,
        showGridToolbar,
        setShowGridToolbar,
        setHandleApproveFunction,
        setHandleRejectFunction,
        displaySwiftTransactionPanelPage,
        clearSwiftTransactionPanelDisplayState,
        handleApprove,
        handleReject,
        getDisplayStatusFromValue, selectedAnyCheckbox,
        setSelectedAnyCheckbox,
        selectedRows,
        setSelectedRows
    }

    return <Context.Provider value={swiftTransactionPanelContext}>{children}</Context.Provider>

};

export const {Consumer} = Context;
